module.exports = __webpack_public_path__ + "media/images/japan/strike-0ea7c4c4760256d7094203bab257ac12.svg";